import { defineComponent as _defineComponent } from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core';
import { faDash, faPipe } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { HatchStyle, PlantVariety } from 'farmdok-rest-api';
import { onMounted, onUnmounted, ref } from 'vue';

import { reportState } from '@/map/composables/useReportState';
import { Product } from '@/shared/api/rest/models';

import MapHatchBackwardDiagonal from './MapHatchBackwardDiagonal.vue';
import MapHatchCheckerboard from './MapHatchCheckerboard.vue';
import MapHatchForwardDiagonal from './MapHatchForwardDiagonal.vue';
import MapHatchGrid from './MapHatchGrid.vue';
import MapHatchHorizontal from './MapHatchHorizontal.vue';
import MapHatchVertical from './MapHatchVertical.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportLegend',
  props: {
    varieties: null,
    crops: null,
    useCrops: { type: Boolean },
    initialTop: null,
    initialLeft: null
  },
  setup(__props: any) {

const props = __props as {
  varieties: PlantVariety[];
  crops: Product[];
  useCrops: boolean;
  initialTop: number;
  initialLeft: number;
}

library.add(faDash);
library.add(faPipe);



const legend = ref<HTMLDivElement | null>(null);

let isDragging = false;
let isResizing = false;
let resizeDirection = '';
let offsetX = 0;
let offsetY = 0;
let initialWidth = 0;
let initialHeight = 0;
let initialMouseX = 0;
let initialMouseY = 0;

const BORDER_THRESHOLD = 20;

const startAction = (e: MouseEvent) => {
  if (resizeDirection) {
    isResizing = true;
    initialWidth = legend.value!.offsetWidth;
    initialHeight = legend.value!.offsetHeight;
    initialMouseX = e.clientX;
    initialMouseY = e.clientY;
  } else {
    isDragging = true;
    offsetX = e.clientX - legend.value!.offsetLeft;
    offsetY = e.clientY - legend.value!.offsetTop;
  }
};

const updateCursor = (e: MouseEvent) => {
  const rect = legend.value!.getBoundingClientRect();
  const withinRight = Math.abs(e.clientX - rect.right) <= BORDER_THRESHOLD;
  const withinBottom = Math.abs(e.clientY - rect.bottom) <= BORDER_THRESHOLD;

  if (withinBottom) {
    resizeDirection = 'bottom';
    legend.value!.style.cursor = 'ns-resize';
  } else if (withinRight) {
    resizeDirection = 'right';
    legend.value!.style.cursor = 'ew-resize';
  } else {
    resizeDirection = '';
    legend.value!.style.cursor = 'move';
  }
};

const resetCursor = () => {
  if (!isDragging && !isResizing) {
    legend.value!.style.cursor = 'default';
  }
};

const handleMouseMove = (e: MouseEvent) => {
  if (isDragging) {
    const posX = e.clientX - offsetX;
    const posY = e.clientY - offsetY;

    legend.value!.style.left = `${posX}px`;
    legend.value!.style.top = `${posY}px`;
  } else if (isResizing) {
    const deltaX = e.clientX - initialMouseX;
    const deltaY = e.clientY - initialMouseY;

    if (resizeDirection === 'bottom') {
      legend.value!.style.height = `${initialHeight + deltaY}px`;
    } else if (resizeDirection === 'right') {
      legend.value!.style.width = `${initialWidth + deltaX}px`;
    }

    updateContainerSize();
  }
};

const stopActions = () => {
  isDragging = false;
  isResizing = false;
  resizeDirection = '';
};

const updateContainerSize = () => {
  const wrapper = legend.value!.querySelector('.legend-wrapper') as HTMLElement;
  const wrapperWidth = wrapper.scrollWidth;
  legend.value!.style.width = `${wrapperWidth}px`;
};

onMounted(() => {
  document.addEventListener('mousemove', handleMouseMove);
  document.addEventListener('mouseup', stopActions);
});

onUnmounted(() => {
  document.removeEventListener('mousemove', handleMouseMove);
  document.removeEventListener('mouseup', stopActions);
});

return { __sfc: true,props, legend, isDragging, isResizing, resizeDirection, offsetX, offsetY, initialWidth, initialHeight, initialMouseX, initialMouseY, BORDER_THRESHOLD, startAction, updateCursor, resetCursor, handleMouseMove, stopActions, updateContainerSize, FontAwesomeIcon, HatchStyle, reportState, MapHatchBackwardDiagonal, MapHatchCheckerboard, MapHatchForwardDiagonal, MapHatchGrid, MapHatchHorizontal, MapHatchVertical }
}

})